import React, { useEffect } from 'react'
import { Button, Switch, Table } from 'antd'
import { ColumnsType } from 'antd/es/table'
import { baseAuthModel } from '../authModel'
import { authService, IAuthDetail } from '../authService'
import { globalPrompt } from '@/components/message'
import { SyncOutlined } from '@ant-design/icons'

export function DataTable() {
    const { dataSource, selectedRowKeys, pgCfg, loading, setEditCarVisible, loadData, setSelectedRowKeys } = baseAuthModel()

    useEffect(() => {
        loadData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    const disableUser = async (record: any, check: number) => {
        const updateRet = await authService.edit({
            id: record.id,
            status: check ? 1 : 0,
            // pwd:record.pwd
        })
        if (updateRet.success) {
            await globalPrompt('message', { type: 'success', text: '修改成功!' })

            loadData()
        } else {
            await globalPrompt('message', { type: 'error', text: '修改失败!' + updateRet.retMsg })
        }
    }
    const columns: ColumnsType<IAuthDetail> = [
        {
            title: '序号',
            width: 60,
            align: 'center',
            render: (t, r, i) => i + 1,
        },
        {
            title: '账户',
            width: 120,
            align: 'center',
            dataIndex: 'accountName',
        },
        {
            title: '角色',
            width: 160,
            align: 'center',
            dataIndex: 'type',
        },
        {
            title: '名称',
            width: 160,
            align: 'center',
            dataIndex: 'name',
        },
        {
            title: '密码',
            width: 100,
            align: 'center',
            dataIndex: 'pwds',
            render: (text, record, index) => <span className={'background-filter'}>{text}</span>,
        },
        {
            title: '操作',
            width: 140,
            align: 'center',
            render: (text, record, index) => (
                <>
                    <Button shape="round" onClick={() => setEditCarVisible({ visible: true, value: { ...record } })}>
                        <SyncOutlined style={{ cursor: 'pointer' }} />
                        重置密码
                    </Button>
                    {/* <Button onClick={() => onDelete([record])}><DeleteOutlined style={{cursor: 'pointer'}}/></Button> */}
                </>
            ),
        },
        {
            title: '状态',
            width: 100,
            dataIndex: 'status',
            fixed: 'right',
            align: 'center',
            render: (text, record) => (
                <Switch
                    disabled={record.type === '管理员' || record.type === '超级管理员'}
                    checkedChildren={'开启'}
                    unCheckedChildren={'关闭'}
                    checked={+(record.status ?? 0) ? false : true}
                    onChange={(checked: any, e: any) => {
                        e.stopPropagation()
                        disableUser(record, checked ? 0 : 1)
                    }}
                />
            ),
        },
    ]

    //点击行选高亮
    const onRow = (record: IAuthDetail) => {
        let findObj = selectedRowKeys.find((item) => item.id === record.id)
        if (findObj) {
            let newSelectedRowKeys = selectedRowKeys.filter((item) => item.id !== record.id)
            setSelectedRowKeys(newSelectedRowKeys)
        } else {
            setSelectedRowKeys((origin) => [...origin, record])
        }
    }

    return (
        <Table
            rowKey={(record) => record?.id as string}
            loading={loading}
            // rowSelection={{
            //     //全部选中时 (存row[])
            //     onSelectAll: (selected, selectedRows, changeRows) => {
            //         selected ? setSelectedRowKeys((origin) => [...origin, ...changeRows])
            //             : setSelectedRowKeys((origin) => {
            //                 let changeRowId = changeRows.map(item => item.id);
            //                 return origin.filter(item => changeRowId.indexOf(item.id) < 0)
            //             });
            //     },
            //     onSelect: (record, selected, selectedRows) => onRow(record),
            //     selectedRowKeys: selectedRowKeys.map(item => item.id as string)
            // }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                position: ['bottomRight'],
                showTotal: () => `共${pgCfg.total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize })
                },
                showSizeChanger: true,
            }}
            bordered
            onRow={(record) => ({
                onClick: () => onRow(record),
                onContextMenu: (e) => {
                    e.preventDefault()
                    setSelectedRowKeys([record])
                },
            })}
            scroll={{ x: 'max-content', y: 'calc(100vh - 350px)' }}
        />
    )
}
